<template>
  <StandardDropdown
    v-bind="$attrs"
    theme="purple"
  />
</template>

<script>
import StandardDropdown from './StandardDropdown.vue'

export default {
  name: 'StandardPurpleDropdown',
  components: {
    StandardDropdown
  },
  inheritAttrs: false
}
</script>
